"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Option = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 9a3 3 0 110 6 3 3 0 010-6zm12 3a3 3 0 10-6 0 3 3 0 006 0zm6-3a3 3 0 110 6 3 3 0 010-6z", clipRule: "evenodd" })); };
exports.Option = Option;
//# sourceMappingURL=option.js.map